import { useNavigate } from "react-router-dom";
import { useImpersonation } from "@/hooks/useImpersonation";
import { Button } from "@/components/ui/button";
import { Eye, X } from "lucide-react";

export const ImpersonationBanner = () => {
  const { impersonatedCreator, stopImpersonation, isImpersonating } = useImpersonation();
  const navigate = useNavigate();

  if (!isImpersonating || !impersonatedCreator) return null;

  const handleExit = () => {
    stopImpersonation();
    navigate("/admin");
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-yellow-500 text-yellow-950 px-4 py-2">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Eye className="h-4 w-4" />
          <span className="font-medium">
            Viewing as: {impersonatedCreator.name}
          </span>
          <span className="text-yellow-800 text-sm">(Admin Impersonation Mode)</span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={handleExit}
          className="text-yellow-950 hover:bg-yellow-600 hover:text-yellow-950"
        >
          <X className="h-4 w-4 mr-1" />
          Exit
        </Button>
      </div>
    </div>
  );
};
